import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ImageCropperModule, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FormsModule } from '@angular/forms';

import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';


@Component({
  selector: 'image-crop-dialog',
  templateUrl: './image-crop-dialog.component.html',
  styleUrls: ['./image-crop-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonModule,
    DialogModule,
    DynamicDialogModule,
    ImageCropperModule,
    FormsModule,
    TranslateModule
]
})
export class ImageCropDialogComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  translate = inject(TranslateService);


  imageChangedEvent: any = '';
  // Blob(File)
  imageFile: any
  croppedImage: any = '';
  canvasRotation = 0;
  rotation = 0;
  scale = 1;
  showCropper = false;
  containWithinAspectRatio = true;
  transform: ImageTransform = {};
  header: string = '';
  cropperWidth: number=0;
  cropperHeight: number = 0;

  roundCropper:boolean=false;
  aspectRatio: number = 4 / 3;


  constructor() {
    this.imageFile = this.config.data?.imageFile;
    this.header = this.config.data?.header;
    this.roundCropper = this.config.data?.roundCropper ? this.config.data?.roundCropper : false;
    this.aspectRatio = this.config.data?.aspectRatio ? this.config.data?.aspectRatio : 4 / 3;
  }

  doneCropping() {
    this.ref.close({ image: this.croppedImage });
  }


  fileChangeEvent(event: any): void {

    this.imageChangedEvent = event;

  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;

  }

  imageLoaded() {
    this.showCropper = true;

  }

  cropperReady(event: any) {
    // Cropper ready
  }

  loadImageFailed() {
    // console.log('Load failed');
  }

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
  }


  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV
    };
  }

  resetImage() {
    this.scale = 1;
    this.rotation = 0;
    this.canvasRotation = 0;
    this.transform = {};
  }

  zoomOut() {
    this.scale -= .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    this.scale += .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  toggleContainWithinAspectRatio() {
    this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }

  updateRotation() {
    this.transform = {
      ...this.transform,
      rotate: this.rotation
    };
  }

}
